import { render, staticRenderFns } from "./TribunalInput.vue?vue&type=template&id=3dc198da"
import script from "./TribunalInput.vue?vue&type=script&lang=js"
export * from "./TribunalInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports